import { render, staticRenderFns } from "./ViewGatDialog.vue?vue&type=template&id=9b54b07c&scoped=true&"
import script from "./ViewGatDialog.vue?vue&type=script&lang=js&"
export * from "./ViewGatDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b54b07c",
  null
  
)

export default component.exports